(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var grid = section.querySelector('[id^="gallery-grid-"]');
      if (!grid) return;
      var items = Array.prototype.slice.call(grid.querySelectorAll('.gallery-item'));
      if (!items.length) return;

      /* ---------- Masonry row-span (left-to-right order, natural heights) ---------- */
      // CSS Grid fills items left-to-right in DOM order. We give each item a
      // grid-row span proportional to its image's aspect ratio so columns stay
      // tightly packed (staggered) while reading order is preserved.
      function spanItem(item) {
        var media = item.querySelector('img, svg');
        var width = item.getBoundingClientRect().width;
        if (!width) return;
        var ratio = 1; // square fallback (e.g. SVG placeholder)
        if (media) {
          var nw = media.naturalWidth || parseFloat(media.getAttribute('width')) || 0;
          var nh = media.naturalHeight || parseFloat(media.getAttribute('height')) || 0;
          if (nw && nh) ratio = nh / nw;
        }
        var cs = getComputedStyle(grid);
        var row = parseFloat(cs.gridAutoRows) || 1;
        var gap = parseFloat(cs.rowGap || cs.gap) || 0;
        var target = width * ratio;
        var span = Math.max(1, Math.round((target + gap) / (row + gap)));
        item.style.gridRowEnd = 'span ' + span;
      }
      function layout() { items.forEach(spanItem); }

      // Initial pass (uses width/height attrs so it works before pixels load),
      // then a corrective pass once each image actually loads.
      layout();
      items.forEach(function (item) {
        var img = item.querySelector('img');
        if (img && !img.complete) {
          img.addEventListener('load', function () { spanItem(item); });
        }
      });

      var rafId;
      window.addEventListener('resize', function () {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(layout);
      });

      var lightbox = section.querySelector('[id^="gallery-lightbox-"]');
      var lbImg    = lightbox && lightbox.querySelector('[data-gl-img]');
      var lbCap    = lightbox && lightbox.querySelector('[data-gl-cap]');
      var lbClose  = lightbox && lightbox.querySelector('[data-gl-close]');
      var lbPrev   = lightbox && lightbox.querySelector('[data-gl-prev]');
      var lbNext   = lightbox && lightbox.querySelector('[data-gl-next]');
      var currentIdx = 0;

      /* ---------- Filter buttons (delegated, listens to gallery-head) ---------- */
      function applyFilter(cat) {
        items.forEach(function (item) {
          var match = cat === 'all' || item.getAttribute('data-cat') === cat;
          item.style.display = match ? '' : 'none';
        });
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gallery-filter]');
        if (!btn) return;
        var siblings = btn.parentNode.querySelectorAll('[data-gallery-filter]');
        siblings.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyFilter(btn.getAttribute('data-gallery-filter') || 'all');
      });

      /* ---------- Lightbox ---------- */
      function visibleItems() {
        return items.filter(function (it) { return it.style.display !== 'none'; });
      }
      function openLightbox(idx) {
        var list = visibleItems();
        if (!list.length || !lightbox) return;
        currentIdx = ((idx % list.length) + list.length) % list.length;
        var item = list[currentIdx];
        var src  = item.getAttribute('href');
        var img  = item.querySelector('img');
        var cap  = item.querySelector('.gallery-item-caption');
        if (lbImg) {
          lbImg.src = src || '';
          lbImg.alt = img ? img.alt : '';
        }
        if (lbCap) lbCap.textContent = cap ? cap.textContent : '';
        lightbox.hidden = false;
        // Force reflow so the visibility transition runs the first time.
        void lightbox.offsetWidth;
        lightbox.classList.add('is-open');
        document.body.classList.add('lightbox-open');
      }
      function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-open');
        document.body.classList.remove('lightbox-open');
        // Hide after fade-out completes so it leaves the a11y tree.
        setTimeout(function () {
          if (!lightbox.classList.contains('is-open')) lightbox.hidden = true;
        }, 280);
      }
      function step(delta) { openLightbox(currentIdx + delta); }

      items.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          var list = visibleItems();
          var idx  = list.indexOf(item);
          openLightbox(idx >= 0 ? idx : 0);
        });
      });

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev)  lbPrev.addEventListener('click', function () { step(-1); });
      if (lbNext)  lbNext.addEventListener('click', function () { step(1); });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lightbox || !lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape')     closeLightbox();
        if (e.key === 'ArrowLeft')  step(-1);
        if (e.key === 'ArrowRight') step(1);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-gallery-section]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-gallery-section]');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function youtubeId(url) {
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
      return m ? m[1] : null;
    }
    function vimeoId(url) {
      var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return m ? m[1] : null;
    }
    function embedMarkup(url) {
      var yt = youtubeId(url);
      if (yt) {
        return '<iframe src="https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      }
      var vm = vimeoId(url);
      if (vm) {
        return '<iframe src="https://player.vimeo.com/video/' + vm + '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      }
      // Direct video file
      return '<video src="' + url + '" controls autoplay playsinline></video>';
    }

    function init(figure) {
      var trigger = figure.querySelector('[data-story-video-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var url = trigger.getAttribute('data-video-url');
        if (!url) return;
        figure.insertAdjacentHTML('beforeend', embedMarkup(url));
        figure.classList.add('is-playing');
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-story-video]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-announcement"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init() {
      var bars = document.querySelectorAll('.announcement-bar[data-rotate]');
      bars.forEach(function(bar) {
        var slides = bar.querySelectorAll('.announcement-slide');
        if (slides.length <= 1) return;

        var seconds = parseFloat(bar.getAttribute('data-rotate'));
        if (isNaN(seconds) || seconds <= 0) seconds = 4;
        var interval = seconds * 1000;
        var current = 0;
        var paused = false;

        // Pause rotation when user hovers (better UX)
        bar.addEventListener('mouseenter', function() { paused = true; });
        bar.addEventListener('mouseleave', function() { paused = false; });

        setInterval(function() {
          if (paused) return;
          slides[current].classList.remove('is-active');
          current = (current + 1) % slides.length;
          slides[current].classList.add('is-active');
        }, interval);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-collection"]) return;
  try {
    
  /* ----- Collection filter drawer + auto-submit controller ----- */
  (function () {
    var form = document.getElementById('cbFilterForm');
    if (!form) return;

    var drawer = document.getElementById('cbFilters');
    var backdrop = form.querySelector('.cb-filter-backdrop');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('[data-cb-filter-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-cb-filter-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Auto-submit on any filter input or sort change. Strip empty price inputs
       so the URL stays clean, and reset pagination to page 1. */
    function submitForm() {
      /* remove empty fields so they don't pollute the query string */
      Array.prototype.forEach.call(form.elements, function (el) {
        if ((el.type === 'number' || el.type === 'text') && el.value === '') {
          el.disabled = true;
        }
      });
      /* drop existing page param by removing any hidden page input — paginate
         handles page via the URL, and a fresh filter should land on page 1. */
      form.submit();
    }

    /* Price bucket checkboxes — only one bucket can be selected at a time.
       Checking one mirrors its data-min/data-max into the hidden min/max
       inputs and unchecks the other buckets; unchecking clears both. */
    function syncPriceBucket(activeInput) {
      var minHidden = form.querySelector('.cb-price-min');
      var maxHidden = form.querySelector('.cb-price-max');
      if (!minHidden || !maxHidden) return;
      if (activeInput && activeInput.checked) {
        var bucketMin = activeInput.getAttribute('data-min') || '';
        var bucketMax = activeInput.getAttribute('data-max') || '';
        /* Shopify min/max params expect a dollar amount, not cents */
        minHidden.value = (parseInt(bucketMin, 10) / 100).toString();
        maxHidden.value = (parseInt(bucketMax, 10) / 100).toString();
        form.querySelectorAll('.cb-price-bucket').forEach(function (b) {
          if (b !== activeInput) b.checked = false;
        });
      } else {
        minHidden.value = '';
        maxHidden.value = '';
      }
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('.cb-price-bucket')) {
        syncPriceBucket(t);
        submitForm();
        return;
      }
      if (t.matches('input[type="checkbox"], [data-cb-sort]')) {
        submitForm();
      }
    });

    /* Price number inputs (legacy fallback if any remain): submit on Enter / blur */
    form.querySelectorAll('.cb-price-input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitForm(); }
      });
      input.addEventListener('change', function () { submitForm(); });
    });

    /* ----- Load More (Section Rendering API) -----
       Fetches the next page of this section only (?page=N&section_id=...),
       appends its grid items, then updates the button with the following
       page URL. On the last page, the button is removed. */
    var loadBtn = form.querySelector('[data-cb-loadmore]');
    if (loadBtn) {
      var grid = form.querySelector('.cb-grid');
      var wrap = form.querySelector('[data-cb-loadmore-wrap]');
      var label = loadBtn.querySelector('.cb-loadmore-label');

      function resetBtn() {
        loadBtn.classList.remove('is-loading');
        loadBtn.disabled = false;
        label.textContent = 'Load More';
      }

      loadBtn.addEventListener('click', function () {
        var nextUrl = loadBtn.getAttribute('data-next-url');
        if (!nextUrl || loadBtn.classList.contains('is-loading')) return;

        var url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', loadBtn.getAttribute('data-section-id'));

        loadBtn.classList.add('is-loading');
        loadBtn.disabled = true;
        label.textContent = 'Loading…';

        fetch(url.toString())
          .then(function (r) {
            if (!r.ok) throw new Error('Load more failed: ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('.cb-grid');
            var appended = [];
            if (newGrid) {
              /* Append every direct child — works whatever markup
                 product-grid-item outputs */
              Array.prototype.slice.call(newGrid.children).forEach(function (item) {
                if (item.classList.contains('cb-empty')) return;
                var node = document.importNode(item, true);
                grid.appendChild(node);
                appended.push(node);
              });
            }

            /* Let quick-add / wishlist / other scripts bind to the new items */
            document.dispatchEvent(new CustomEvent('valor:products-appended', {
              detail: { cards: appended }
            }));

            var nextBtn = doc.querySelector('[data-cb-loadmore]');
            if (nextBtn) {
              loadBtn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
              var newShown = doc.querySelector('[data-cb-shown]');
              var shown = form.querySelector('[data-cb-shown]');
              if (newShown && shown) shown.textContent = newShown.textContent;
              resetBtn();
            } else if (wrap) {
              wrap.remove(); /* last page reached */
            }
          })
          .catch(function (err) {
            console.error(err);
            resetBtn();
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-products"] && !Shopify.designMode) return;
  try {
    
  /* Quick Add behaviour lives in assets/valor-quick-add.js (shared with
     valor-collection). Only section-local logic (mobile slider dots) below. */

  /* ----- Slider dots — dynamic count based on visible cards per view -----
     The number of dots = (cards − cardsPerView + 1), so at desktop-medium
     where 3 of 4 cards are visible we render 2 dots instead of 4. Dots are
     rebuilt on resize so the count tracks the active breakpoint. */
  (function() {
    function init() {
      var sections = document.querySelectorAll('.products-section[data-mobile-slider="true"]');
      sections.forEach(function(section) {
        var row = section.querySelector('.products-row');
        var dotsContainer = section.querySelector('.products-slider-dots');
        if (!row || !dotsContainer) return;

        function cardsPerView() {
          var cards = row.querySelectorAll('.product-card');
          if (!cards.length) return 1;
          var cardW = cards[0].getBoundingClientRect().width;
          if (cardW <= 0) return 1;
          // Use rowClientWidth/cardW rounded to a sensible integer.
          var n = Math.max(1, Math.round(row.clientWidth / cardW));
          return Math.min(n, cards.length);
        }

        function rebuildDots() {
          var cards = row.querySelectorAll('.product-card');
          if (!cards.length) { dotsContainer.innerHTML = ''; return; }
          var perView = cardsPerView();
          var dotCount = Math.max(1, cards.length - perView + 1);
          // If only 1 page worth of content, hide dots entirely.
          if (dotCount <= 1 || window.innerWidth > 1152) {
            dotsContainer.innerHTML = '';
            return;
          }
          if (dotsContainer.children.length !== dotCount) {
            dotsContainer.innerHTML = '';
            for (var i = 0; i < dotCount; i++) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'products-slider-dot' + (i === 0 ? ' is-active' : '');
              b.setAttribute('data-slide', String(i));
              b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
              dotsContainer.appendChild(b);
            }
          }
        }

        function activeIndex() {
          var cards = row.querySelectorAll('.product-card');
          if (!cards.length) return 0;
          var scrollLeft = row.scrollLeft;
          var dotCount = dotsContainer.children.length;
          if (!dotCount) return 0;
          // Find nearest card start position.
          var nearest = 0;
          var bestDelta = Infinity;
          for (var i = 0; i < cards.length; i++) {
            var delta = Math.abs((cards[i].offsetLeft - row.offsetLeft) - scrollLeft);
            if (delta < bestDelta) { bestDelta = delta; nearest = i; }
          }
          // Clamp to dot range.
          return Math.min(nearest, dotCount - 1);
        }

        function updateActive() {
          if (window.innerWidth > 1152) return;
          var dots = dotsContainer.querySelectorAll('.products-slider-dot');
          if (!dots.length) return;
          var idx = activeIndex();
          dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === idx); });
        }

        // Delegated click — works even after dots are rebuilt on resize.
        dotsContainer.addEventListener('click', function(e) {
          var btn = e.target.closest('.products-slider-dot');
          if (!btn) return;
          var idx = parseInt(btn.getAttribute('data-slide'), 10) || 0;
          var cards = row.querySelectorAll('.product-card');
          if (!cards[idx]) return;
          row.scrollTo({
            left: cards[idx].offsetLeft - row.offsetLeft,
            behavior: 'smooth'
          });
        });

        var rafPending = false;
        row.addEventListener('scroll', function() {
          if (rafPending) return;
          rafPending = true;
          window.requestAnimationFrame(function() {
            updateActive();
            rafPending = false;
          });
        });
        var resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            rebuildDots();
            updateActive();
          }, 120);
        });
        rebuildDots();
        updateActive();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var sectionId = section.dataset.sectionId || '';
      var row   = section.querySelector('.reviews-row');
      var track = section.querySelector('.reviews-track');
      var dots  = section.querySelectorAll('.review-dot');
      if (!row || !track || dots.length === 0) return;
      var cards = row.querySelectorAll('.review-card');
      if (cards.length < 2) return;

      var currentIdx = 0;
      var isDragging = false;
      var startX = 0;
      var dragX = 0;
      var baseOffset = 0;

      function visibleCount() {
        if (window.innerWidth <= 600)  return 1;
        if (window.innerWidth <= 991) return 2;
        return 3;
      }
      function stepSize() {
        var card = cards[0];
        if (!card) return 0;
        var s = window.getComputedStyle(row);
        var gap = parseFloat(s.columnGap || s.gap || '0') || 0;
        return card.offsetWidth + gap;
      }
      function maxIndex() {
        return Math.max(0, cards.length - visibleCount());
      }
      function updateDotsVisibility() {
        var max = maxIndex();
        dots.forEach(function (d, i) {
          d.style.display = i <= max ? '' : 'none';
        });
      }
      function goTo(idx) {
        var clamped = Math.max(0, Math.min(idx, maxIndex()));
        currentIdx = clamped;
        var offset = stepSize() * clamped;
        row.style.transform = 'translateX(-' + offset + 'px)';
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        var active = section.querySelector('.review-dot[data-slide="' + clamped + '"]');
        if (active) active.classList.add('is-active');
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (dot.style.display === 'none') return;
          var idx = parseInt(dot.getAttribute('data-slide') || '0', 10);
          goTo(idx);
        });
      });

      function onDown(e) {
        isDragging = true;
        track.classList.add('is-dragging');
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        baseOffset = stepSize() * currentIdx;
        dragX = 0;
      }
      function onMove(e) {
        if (!isDragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        dragX = x - startX;
        row.style.transform = 'translateX(' + (-baseOffset + dragX) + 'px)';
      }
      function onUp() {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        var threshold = stepSize() * 0.2;
        var target = currentIdx;
        if (dragX < -threshold) target = currentIdx + 1;
        else if (dragX > threshold) target = currentIdx - 1;
        goTo(target);
        dragX = 0;
      }
      track.addEventListener('mousedown', onDown);
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      window.addEventListener('mouseleave', onUp);
      track.addEventListener('touchstart', onDown, { passive: true });
      track.addEventListener('touchmove', onMove, { passive: true });
      track.addEventListener('touchend', onUp);
      track.addEventListener('touchcancel', onUp);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('click', function (e) {
        if (Math.abs(dragX) > 5) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateDotsVisibility();
          /* Clamp the current index if the new viewport has fewer pages */
          if (currentIdx > maxIndex()) currentIdx = maxIndex();
          goTo(currentIdx);
        }, 150);
      });
      updateDotsVisibility();
      goTo(0);
    }

    function initAll() {
      document.querySelectorAll('.reviews-section').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Re-init when the section is re-rendered in Customize
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.reviews-section');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-upsell"] && !Shopify.designMode) return;
  try {
    
  /* "Add to Build" → AJAX add-to-cart → refresh + open Impulse cart drawer.
     Uses window.refreshValorCartDrawer (shared helper from valor-quick-add.js). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    if (btn.classList.contains('is-adding')) return;

    var labelEl = btn.querySelector('.upsell-toggle__label');
    var origLabel = labelEl ? labelEl.textContent : '';
    btn.classList.add('is-adding');
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (out) {
        if (!out.ok) {
          if (labelEl) labelEl.textContent = (out.data && (out.data.description || out.data.message)) ? 'Unavailable' : 'Try again';
          setTimeout(function () {
            if (labelEl) labelEl.textContent = origLabel;
            btn.disabled = false;
            btn.classList.remove('is-adding');
          }, 1400);
          return;
        }
        if (labelEl) labelEl.textContent = 'Added ✓';
        if (typeof window.refreshValorCartDrawer === 'function') {
          window.refreshValorCartDrawer({ product: out.data });
        }
        setTimeout(function () {
          if (labelEl) labelEl.textContent = origLabel;
          btn.disabled = false;
          btn.classList.remove('is-adding');
        }, 1400);
      })
      .catch(function () {
        if (labelEl) labelEl.textContent = 'Network error';
        setTimeout(function () {
          if (labelEl) labelEl.textContent = origLabel;
          btn.disabled = false;
          btn.classList.remove('is-adding');
        }, 1400);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
